import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { useApplicationContext } from 'shared/map-search/containers/ApplicationContext';
import { useNewbuildingPolygonsContext } from 'shared/map-search/containers/Map/MapLayers/NewbuildingsPolygons/context';

export const PolygonHoverHandlers: React.FC = () => {
  const { newbuildingsPolygonsManager } = useNewbuildingPolygonsContext();
  const { config } = useApplicationContext();
  const isEnabled = config.get('Newbuilding.NewbuildingPin.Enabled');
  const device = useDeviceType();

  const isAvailable = isEnabled && device === 'desktop';

  const handleMouseEnter = React.useCallback(
    (event: YMaps.IEvent) => {
      const objectId = event.get<string>('objectId');
      newbuildingsPolygonsManager.setHoveredPolygon(Number(objectId));
    },
    [newbuildingsPolygonsManager],
  );

  const handleMouseLeave = React.useCallback(() => {
    newbuildingsPolygonsManager.setHoveredPolygon(null);
  }, [newbuildingsPolygonsManager]);

  React.useEffect(() => {
    if (!isAvailable) {
      return;
    }

    newbuildingsPolygonsManager.objectManager.objects.events.add('mouseenter', handleMouseEnter);
    newbuildingsPolygonsManager.objectManager.objects.events.add('mouseleave', handleMouseLeave);

    return () => {
      newbuildingsPolygonsManager.objectManager.objects.events.remove('mouseenter', handleMouseEnter);
      newbuildingsPolygonsManager.objectManager.objects.events.remove('mouseleave', handleMouseLeave);
    };
  }, [handleMouseEnter, handleMouseLeave, isAvailable, newbuildingsPolygonsManager]);

  return null;
};
